import { render, staticRenderFns } from "./GeneralSettingContactAddress.vue?vue&type=template&id=8df6763c&"
import script from "./GeneralSettingContactAddress.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports